import { apiClient } from "@/services/api";


const state = () => ({
    configTarjaEnquete: null,
    tarjaParams: null
})

const getters = {
    getConfigTarja: state => {
        return state.configTarjaEnquete
    },
    getTarjaParams: state => {
        return state.tarjaParams
    }
}

const actions = {
    async getConfigTarjaEnquete({ commit }, payload) {
        const { cod_producao } = payload;

        const response = await apiClient.get(`/getProducaoConfigTarjaEnquete/${cod_producao}`)
        if(response.data.config) {
            commit('setConfigTarjaEnquete', response.data.config)
        }
    },
    assignTarjaParams({ commit }, payload) {
        commit('setTarjaParams', payload);
    }
}

const mutations = {
    setConfigTarjaEnquete(state, payload) {
        state.configTarjaEnquete = payload
    },
    setTarjaParams(state, payload) {
        state.tarjaParams = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}